import { NotificationList } from '@/components/NotificationList';

export default function Notifications() {
  return (
    <div className="container mx-auto py-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Notificações</h1>
        <div className="bg-card rounded-lg border">
          <NotificationList />
        </div>
      </div>
    </div>
  );
}